import React from "react";
import InputIngredientPrice from "./InputIngredientPrice";

export function planningIngredientsColumns(
  t,
  { ingredientsPrices, onChangeIngredientPrice = () => () => {} }
) {
  return [
    {
      id: "ingredientesColumn",
      titulo: t("ingredients:ingredients"),
      ordenavel: false,
      estilo: {
        minWidth: "185px",
        width: "25%",
      },
      pegaValor: (linha) => linha.name,
    },
    {
      id: "ingredientPriceColumn",
      titulo: t("planning:register.ingredient.price"),
      ordenavel: false,
      infoMessage: t("planning:register.ingredient.price-info"),
      pegaValor: (linha) => (
        <InputIngredientPrice
          value={ingredientsPrices ? ingredientsPrices[linha.id] : ""}
          onChange={onChangeIngredientPrice(linha.id)}
        />
      ),
    },
  ];
}
